import axiosInstance from '../common/axios';
const backendUrl = process.env.REACT_APP_BACKEND_URL;


export async function getProductVariant(id) {
  const res = await axiosInstance.get(`${backendUrl}/api/product-variants/${id}`);
  return res.data;
} 

export async function saveProductVariant(data) {
  const res = await axiosInstance.post(`${backendUrl}/api/product-variants`, data);
  return res.data;
}

export async function updateProductVariant(id, data){

  const res = await axiosInstance.put(`${backendUrl}/api/product-variants/${id}`, data);
  return res.data;
}


export async function fetchProductVariants() {
     return axiosInstance.get(`${backendUrl}/api/product-variants`);
    }

 export const deleteProductVariant = async (id) => {
  const res = await axiosInstance.delete(`${backendUrl}/api/product-variants/${id}`);
  return res.data;
  };
